import React from 'react';
import { CheckCircle } from 'lucide-react';
import './FeatureCards.css';

const FeatureCards = ({ title, subtitle, features ,end, icon=true}) => {
    return (
        <div className="feature-cards-section">
            <h2 className="feature-cards-title">{title}</h2>
            {subtitle && (
                <p className="feature-cards-subtitle">{subtitle}</p>
            )}
            <div className="feature-cards-grid">
                {Array.isArray(features) && features.map((feature, i) => (
                    <div key={i} className="feature-card">
                        <div className="feature-card-content">
                            {icon &&
                                <CheckCircle size={22} color="#16A34A" style={{ marginTop: '2px', flexShrink: 0 }} />
                            }
                            <div className="feature-card-text">
                                {feature?.title && <span className="feature-card-title" dangerouslySetInnerHTML={{ __html: feature.title }}/>}
                                {feature?.text && (
                                    <span className="feature-card-subtitle" dangerouslySetInnerHTML={{ __html: feature.text }} />
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {end && (
                <p className="feature-cards-subtitle">{end}</p>
            )}
        </div>
    );
};

export default FeatureCards;
